import {
  CartData,
  type CustomerType,
  getFuelTypeFromCart,
  saveCart,
  saveCartId,
} from "@origin-digital/sales-cart";
import type { IFuelTypes } from "@origin-digital/sales-common";
import { config } from "src/config";
import { CampaignPlans } from "./campaignPlansAPI";
import { getCustomerType } from "./pageContext";

export const getCartFuel = (cartData: CartData): IFuelTypes | undefined =>
  getFuelTypeFromCart(cartData) ?? undefined;

type SalesCartOptions = Pick<CartData, "customerType" | "isExistingCustomer">;

export const createSalesCart = async (
  originAddressId: string,
  plans?: CampaignPlans,
  {
    customerType = getCustomerType(),
    isExistingCustomer,
  }: SalesCartOptions = {}
): Promise<IFuelTypes | undefined> => {
  const cartData: CartData = {
    addressId: originAddressId,
    channel: "SIMPLE_MOVE",
    customerType,
    ...(isExistingCustomer === true && { isExistingCustomer: true }),
    ...(getCustomerType() === "residential" && customerType === "business"
      ? { userSession: { "movers-widget:entry-customer-type": "residential" } }
      : {}),
    status: "IN_PROGRESS",
    ...(plans && {
      electricity: { payload: plans.electricity },
      gas: { payload: plans.gas },
    }),
  };
  const cartFuel = getCartFuel(cartData);

  const cartId = await saveCart(`${config.apiBasePath}/v1/cart`, cartData);

  if (cartId === "error") {
    throw new Error("Failed to create sales cart");
  }

  saveCartId(cartId);
  return cartFuel;
};

export const createProspectMoveCart = async (
  originAddressId: string,
  customerType: CustomerType
): Promise<void> => {
  const cartId = await saveCart(`${config.apiBasePath}/v1/cart`, {
    addressId: originAddressId,
    channel: "SIMPLE_MOVE",
    customerType,
    status: "IN_PROGRESS",
  });
  if (cartId === "error") throw new Error("Failed to create sales cart");
  saveCartId(cartId);
};
